import { Action } from 'redux';
import { IEditTeamFormProps } from '../../containers/EditTeam/EditTeam.d';
import { appActionTypes } from './actionTypes';
import makeActionCreator from '../../utils/actionCreator';

export const savePageId = makeActionCreator<[string]>(
  appActionTypes.SAVE_PAGE_ID,
  'pageId',
);

export const savePageType = makeActionCreator(
  appActionTypes.SAVE_PAGE_TYPE,
  'pageType'
);

export const showInlineAlert = makeActionCreator(
  appActionTypes.SHOW_INLINE_ALERT,
  'inlineAlert',
);

export const closeInlineAlert = makeActionCreator(
  appActionTypes.CLOSE_INLINE_ALERT,
  'inlineAlert',
);

export const saveTeamSettingsData = makeActionCreator(
  appActionTypes.SAVE_TEAM_SETTINGS_DATA,
  'data',
);

export const saveStoryData = makeActionCreator(
  appActionTypes.SAVE_STORY_DATA,
  'data',
);

export type TAnalyticsTrackData = object;
export type TAnalyticsTrackAction = Action & {
  meta: { analytics: TAnalyticsTrackData };
};
export type TAnalyticsTrackActionCreator = (
  data: TAnalyticsTrackData,
) => TAnalyticsTrackAction;
export const analyticsTrack: TAnalyticsTrackActionCreator = (data) => ({
  type: appActionTypes.ANALYTICS_TRACK,
  meta: { analytics: data },
});

export const editTeamData = makeActionCreator<[IEditTeamFormProps]>(
  appActionTypes.EDIT_TEAM_DATA,
  'data',
);

export const saveNewFrpData = makeActionCreator(
  appActionTypes.SAVE_NEW_FRP_DATA,
  'data',
);

export const saveCause = makeActionCreator(appActionTypes.SAVE_CAUSE, 'cause');

export const saveEvent = makeActionCreator(appActionTypes.SAVE_EVENT, 'event');
